/**
 * Storage keys and fixed values of the chat app — SPEC-2026-09-internal-chat-pwa.
 *
 * `currentUser` is deliberately NOT the product's key: the chat app is its own origin
 * with its own session, and the shared library reads the session through the
 * `CONSTANTS` token, so every lib service follows this key automatically.
 */
export const ChatAppConstants = {
  currentUser: 'currentUserTrendmultiChat',
  /** The install invitation was dismissed on this device (RF-15). */
  installInvitationDismissed: 'trendmultiChatInstallDismissed',
  /** The install event was already reported from this device (RNF-07). */
  installReported: 'trendmultiChatInstallReported',
  /** Name of the product tab work references open in (RF-25). */
  productWindowName: 'trendmulti-app',
};

/** The chat app's own messaging worker, on its own scope (plan AD-09). */
export const CHAT_APP_PUSH_WORKER_URL = '/push/firebase-messaging-sw.js';
export const CHAT_APP_PUSH_WORKER_SCOPE = '/push/';
